let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kj07D"), load("kz1At"), load("1otv1"), load("3UXvk"), load("9RwSd")]).then(() => parcelRequire('1VC5o'));